/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressPrecisionFromJSON, AddressPrecisionToJSON, } from './AddressPrecision';
/**
 * Check if a given object implements the AddressDto interface.
 */
export function instanceOfAddressDto(value) {
    let isInstance = true;
    return isInstance;
}
export function AddressDtoFromJSON(json) {
    return AddressDtoFromJSONTyped(json, false);
}
export function AddressDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rawInput': !exists(json, 'rawInput') ? undefined : json['rawInput'],
        'formattedAddress': !exists(json, 'formattedAddress') ? undefined : json['formattedAddress'],
        'unitNumber': !exists(json, 'unitNumber') ? undefined : json['unitNumber'],
        'levelNumber': !exists(json, 'levelNumber') ? undefined : json['levelNumber'],
        'streetNumber': !exists(json, 'streetNumber') ? undefined : json['streetNumber'],
        'streetName': !exists(json, 'streetName') ? undefined : json['streetName'],
        'streetType': !exists(json, 'streetType') ? undefined : json['streetType'],
        'suburb': !exists(json, 'suburb') ? undefined : json['suburb'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'postcode': !exists(json, 'postcode') ? undefined : json['postcode'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'secondaryStreet': !exists(json, 'secondaryStreet') ? undefined : json['secondaryStreet'],
        'landmark': !exists(json, 'landmark') ? undefined : json['landmark'],
        'precision': !exists(json, 'precision') ? undefined : AddressPrecisionFromJSON(json['precision']),
    };
}
export function AddressDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'rawInput': value.rawInput,
        'formattedAddress': value.formattedAddress,
        'unitNumber': value.unitNumber,
        'levelNumber': value.levelNumber,
        'streetNumber': value.streetNumber,
        'streetName': value.streetName,
        'streetType': value.streetType,
        'suburb': value.suburb,
        'state': value.state,
        'postcode': value.postcode,
        'country': value.country,
        'secondaryStreet': value.secondaryStreet,
        'landmark': value.landmark,
        'precision': AddressPrecisionToJSON(value.precision),
    };
}
